// export const requestUrl = 'http://localhost:5000/api/v1'

// export const requestUrl = 'http://192.168.1.16:5000/api/v1'
// export const requestUrl = 'http://125.71.207.97:5000/api/v1'
// export const orgId = 63

// export const requestUrl = 'http://125.71.207.97:4000/api/v1'
// export const orgId = 69
//线上
export const orgId = 69
// export const requestUrl ='http://www.hrnygs.com:4000/api/v1'

export const requestUrl = 'http://www.sczerun.com:4000/api/v1'
// export const requestUrl = 'http://localhost:5000/api/v1'



// WEBPACK FOOTER //
// ./src/common/cons.js